// Generated by scripts/generate-work-labels.js from the web app's en.json; do not edit by hand.

export const WORK_FUNCTION_SHORT_LABELS = {
  ACCORDIONIST: 'Accordionist',
  ACCOUNTING_CLERK: 'Accounting Clerk',
  ACTING_COACH: 'Acting Coach',
  ACTOR: 'Actor',
  ADR_SUPERVISOR: 'ADR Supervisor',
  ANIMAL_WRANGLER: 'Animal Wrangler',
  ANIMATION_STUDIO: 'Animation Studio',
  ANIMATOR_VFX: 'Animator (VFX)',
  ARMOURER: 'Armourer',
  ART_DEPARTMENT_ASSIST: 'Art Dept. Assist.',
  ART_DEPARTMENT_COORDINATOR: 'Art Department Coordinator',
  ART_DIRECTOR: 'Art Director',
  ASSIST_ART_DEPARTMENT_COORDINATOR: 'Assist. Art Department Coordinator',
  ASSIST_ART_DIRECTOR: 'Assist. Art Director',
  ASSIST_COSTUME_DESIGNER: 'Assist. Costume Designer',
  ASSIST_CRAFT_PERSON: 'Assist. Craft Person',
  ASSIST_DIRECTOR_TV: 'Assist. Director (TV)',
  ASSIST_DRESSER: 'Assist. Dresser',
  ASSIST_EDITOR: 'Assist. Editor',
  ASSIST_GREENSPERSON: 'Assist. Greensperson',
  ASSIST_HAIRDRESSER: 'Assist. Hairdresser',
  ASSIST_KEY_CRAFT: 'Assist. Key Craft',
  ASSIST_LOCATION_MANAGER: 'Assist. Location Manager',
  ASSIST_MAKE_UP_ARTIST: 'Assist. Make-up Artist',
  ASSIST_ON_SET_DECORATOR: 'Assist. On Set Decorator',
  ASSIST_ON_SET_PROPS: 'Assist. On Set Props',
  ASSIST_PAINTER: 'Assist. Painter',
  ASSIST_PLASTERER: 'Assist. Plasterer',
  ASSIST_PRODUCTION_COORDINATOR: 'Assist. Production Coordinator',
  ASSIST_PRODUCTION_MANAGER: 'Assist. Production Manager',
  ASSIST_PROPS: 'Assist. Props',
  ASSIST_SCRIPT_SUPERVISOR: 'Assist. Script Supervisor',
  ASSIST_SET_DECORATOR: 'Assist. Set Decorator',
  ASSIST_SFX_MAKE_UP_ARTIST: 'Assist. SFX Make-up Artist',
  ASSIST_TRANSPORT_CAPTAIN: 'Assist. Transport Captain',
  ASSIST_TRANSPORT_COORDINATOR: 'Assist. Transport Coordinator',
  ASSIST_UNIT_MANAGER: 'Assist. Unit Manager',
  ASSIST_VEHICLE_COORDINATOR: 'Assist. Vehicle Coordinator',
  ASSIST_WARDROBE_MISTRESS: 'Assist. Wardrobe Mistress',
  ASSOCIATE_PRODUCER: 'Associate Producer',
  AUDIO_POST_PRODUCTION_HOUSE: 'Audio Post-Production House',
  AUTHOR: 'Author',
  BACKGROUND_ACTOR: 'Background Actor',
  BACKUP_VOCALIST: 'Backup Vocalist',
  BAGPIPER: 'Bagpiper',
  BANJO_PLAYER: 'Banjo Player',
  BASE_CAMP_OPERATOR: 'Base Camp Operator (Tech.)',
  BASSIST: 'Bassist',
  BASSOONIST: 'Bassoonist',
  BEATBOXER: 'Beatboxer',
  BEATMAKER: 'Beatmaker',
  BODY_DOUBLE: 'Body Double',
  BOOM_OPERATOR: 'Boom Operator',
  BTS_CAMERAPERSON: 'BTS Cameraperson',
  CAMERA_ASSIST: 'Camera Assist.',
  CAMERA_CRANE_OPERATOR: 'Camera Crane Operator',
  CAMERA_EQUIPMENT_RENTAL: 'Camera Equipment Rental',
  CAMERA_OPERATOR: 'Camera Operator',
  CAMERA_RENTAL_HOUSE: 'Camera Rental House',
  CAPTIONER: 'Captioner',
  CARPENTER: 'Carpenter',
  CASTING_AGENCY: 'Casting Agency',
  CASTING_DIRECTOR: 'Casting Director',
  CATERING_SERVICES: 'Catering Services',
  CCU_OPERATOR: 'CCU Operator',
  CELLIST: 'Cellist',
  CHOREOGRAPHER: 'Choreographer',
  CINEMA_EQUIPMENT_RENTAL: 'Cinema Equipment Rental',
  CINEMA_STUDIO_RENTAL: 'Cinema Studio Rental',
  CIRCUS_PERFORMER: 'Circus Performer',
  CLARINETIST: 'Clarinetist',
  CLOWN: 'Clown',
  COLORIST: 'Colorist',
  COMEDIAN: 'Comedian',
  COMMERCIAL_ART_DIRECTOR: 'Commercial Art Director',
  COMPOSITOR_VFX: 'Compositor (VFX)',
  CONCEPT_ARTIST_ILLUSTRATOR: 'Concept Artist - Illustrator',
  CONCEPT_ARTIST_VFX: 'Concept Artist (VFX)',
  CONDUCTOR: 'Conductor',
  CONSTRUCTION_COORDINATOR: 'Construction Coordinator',
  CONSTRUCTION_SUPERVISOR: 'Construction Supervisor',
  CONTENT_PRODUCER: 'Content Producer',
  COSTUME_COORDINATOR: 'Costume Coordinator',
  COSTUME_DESIGNER: 'Costume Designer',
  COSTUMES_BUYER: 'Costumes Buyer',
  COSTUMES_SUPERVISOR: 'Costumes Supervisor',
  CRAFT_PERSON: 'Craft Person',
  CREATIVE_AGENCY: 'Creative Agency',
  DANCER_PERFORMER: 'Dancer/Performer',
  DATA_WRANGLER: 'Data Wrangler',
  DECORATION_LEADPERSON: 'Decoration Leadperson',
  DEVELOPMENT_DESIGNER: 'Development Designer',
  DIGITAL_IMAGING_TECHNICIAN: 'Digital Imaging Technician (DIT)',
  DIRECTOR: 'Director',
  DIRECTOR_OF_PHOTOGRAPHY: 'Director of Photography',
  DJ: 'DJ',
  DOCUMENTARY_DIRECTOR: 'Documentary Director',
  DOCUMENTARY_EDITOR: 'Documentary Editor',
  DOLLY_GRIP_OPERATOR: 'Dolly Grip Operator',
  DOUBLE_BASS_PLAYER: 'Double Bass Player',
  DRAFTSPERSON: 'Draftsperson',
  DRAG_PERFORMER: 'Drag Performer',
  DRESSER: 'Dresser',
  DRIVER: 'Driver',
  DRONE_OPERATOR: 'Drone Operator',
  DRUMMER: 'Drummer',
  EDITOR: 'Editor',
  ELECTRIC_GUITARIST: 'Electric Guitarist',
  ELECTRO_BEST_BOY_BEST_GIRL: 'Electro Best Boy/Best Girl',
  ELECTRONIC_CAMERAPERSON: 'Electronic Cameraperson',
  ENVIRONMENT_ARTIST_VFX: 'Environment artist (VFX)',
  EXECUTIVE_PRODUCER: 'Executive Producer',
  FILM_COMMISSION: 'Film Commission',
  FILM_DISTRIBUTION_STUDIO: 'Film Distribution Studio',
  FILM_FESTIVAL: 'Film Festival',
  FILM_SCHOOL: 'Film School',
  FIRST_AID_ATTENDANT: 'First Aid Attendant',
  FIRST_ASSIST_ACCOUNTANT_GENERAL: 'First Assist. Accountant General',
  FIRST_ASSIST_ACCOUNTANT_PAYROLL: 'First Assist. Accountant Payroll',
  FIRST_ASSIST_ACCOUNTING: 'First Assist. Accounting',
  FIRST_ASSIST_CAMERA: '1st Assist. Camera',
  FIRST_ASSIST_DIRECTOR: '1st Assist. Director',
  FIRST_ASSIST_SOUND_EDITOR: '1st Assist. Sound Editor',
  FLUTIST: 'Flutist',
  FOLEY_ARTIST: 'Foley Artist',
  FOLLOW_SPOT_OPERATOR: 'Follow Spot Operator',
  FOOD_STYLIST: 'Food Stylist',
  GAFFER: 'Gaffer',
  GENERATOR_OPERATOR: 'Generator Operator',
  GRAPHIC_ARTIST: 'Graphic Artist',
  GRAPHIC_DESIGNER_SUPERVISOR: 'Graphic Designer Supervisor',
  GREENSPERSON: 'Greensperson',
  GRIP: 'Grip',
  GRIP_BEST_BOY_BEST_GIRL: 'Grip Best Boy/Best Girl',
  GRIP_EQUIPMENT_RENTAL: 'Grip Equipment Rental',
  GUITARIST: 'Guitarist',
  HAIR_DESIGNER: 'Hair Designer',
  HAIRDRESSER: 'Hairdresser',
  HARMONICA_PLAYER: 'Harmonica Player',
  HARPIST: 'Harpist',
  HEAD_CARPENTER: 'Head Carpenter',
  HORN_PLAYER: 'Horn Player',
  IMPERSONATOR: 'Impersonator',
  KEY_CRAFT: 'Key Craft',
  KEY_DRESSER: 'Key Dresser',
  KEY_GREENSPERSON: 'Key Greensperson',
  KEY_GRIP: 'Key Grip',
  KEY_HAIRDRESSER: 'Key Hairdresser',
  KEY_MAKE_UP_ARTIST: 'Key Make-up Artist',
  KEY_MOBILE_SET_UP_TECH: 'Key Mobile Set Up Tech.',
  KEY_MODEL_MAKER: 'Key Model Maker',
  KEY_PROP_MAKER: 'Key Prop Maker',
  KEY_PROPS: 'Key Props',
  KEY_PROPS_BUYER: 'Key Props Buyer',
  KEY_RIGGING_GAFFER: 'Key Rigging Gaffer',
  KEY_RIGGING_GAFFER_BEST_BOY_BEST_GIRL: 'Key Rigging Gaffer Best Boy/Best Girl',
  KEY_RIGGING_GRIP: 'Key Rigging Grip',
  KEY_RIGGING_GRIP_BEST_BOY_BEST_GIRL: 'Key Rigging Grip Best Boy/Best Girl',
  KEY_SET_DECORATOR: 'Key Set Decorator',
  KEY_SPECIALIZED_DECORATION_MAKER: 'Key Specialized Decoration Maker',
  KEY_SPECIALIZED_WARDROBE_TECHNICIAN: 'Key Specialized Wardrobe Technician',
  KEY_WARDROBE_MISTRESS: 'Key Wardrobe Mistress',
  LEADMAN_GRIP: 'Leadman Grip',
  LIGHTING_CONTROL_CONSOLE_OPERATOR: 'Lighting Control Console Operator',
  LIGHTING_EQUIPMENT_RENTAL: 'Lighting Equipment Rental',
  LIGHTING_LEADPERSON: 'Lighting Leadperson',
  LIGHTING_TECHNICIAN: 'Lighting Technician',
  LINE_PRODUCER: 'Line Producer',
  LOCATION_MANAGER: 'Location Manager',
  LOCATION_SCOUT: 'Location Scout',
  LOGISTICS_EQUIPMENT_RENTAL: 'Logistics Equipment Rental',
  MAGICIAN: 'Magician',
  MAKE_UP_ARTIST: 'Make-up Artist',
  MAKE_UP_DESIGNER: 'Make-up Designer',
  MANDOLIN_PLAYER: 'Mandolin Player',
  MIME: 'Mime',
  MOBILE_SET_UP_TECH: 'Mobile Set Up Tech.',
  MODEL: 'Model',
  MODEL_MAKER: 'Model Maker',
  MODEL_MAKER_SUPERVISOR: 'Model Maker Supervisor',
  MOTION_CAPTURE_ACTOR: 'Motion Capture Actor',
  MOTION_GRAPHICS_DESIGNER: 'Motion Graphics Designer',
  MUSIC_COMPOSER: 'Music Composer',
  MUSIC_EDITOR: 'Music Editor',
  MUSIC_PRODUCER: 'Music Producer',
  MUSIC_STUDIO_RENTAL: 'Music Studio Rental',
  NARRATOR: 'Narrator',
  NUDITY_COORDINATOR: 'Nudity Coordinator',
  OBOIST: 'Oboist',
  ON_SET_DECORATOR: 'On Set Decorator',
  ONLINE_EDITOR: 'Online Editor',
  ORGANIST: 'Organist',
  PAINTER: 'Painter',
  PERCUSSIONIST: 'Percussionist',
  PHANTOM_OPERATOR: 'Phantom Operator',
  PHOTOGRAPHER: 'Photographer',
  PIANIST: 'Pianist',
  PLASTERER: 'Plasterer',
  POST_PRODUCTION_ACCOUNTANT: 'Post Production Accountant',
  POST_PRODUCTION_COORDINATOR: 'Post Production Coordinator',
  POST_PRODUCTION_HOUSE: 'Post-Production House',
  POST_PRODUCTION_SUPERVISOR: 'Post Production Supervisor',
  POST_PRODUCTION_TECHNICIAN: 'Post Production Technician',
  PRODUCER: 'Producer',
  PRODUCTION_ACCOUNTANT: 'Production Accountant',
  PRODUCTION_ASSIST: 'Production Assist.',
  PRODUCTION_COMPANY: 'Production Company',
  PRODUCTION_COORDINATOR: 'Production Coordinator',
  PRODUCTION_DESIGNER: 'Production Designer',
  PRODUCTION_MANAGER: 'Production Manager',
  PRODUCTION_SECRETARY: 'Production Secretary',
  PROJECT_MANAGER: 'Project Manager',
  PROP_MAKER: 'Prop Maker',
  PROP_MASTER: 'Prop Master',
  PROPERTY_MANAGER: 'Property Manager',
  PROPS: 'Props',
  PROPS_BUYER: 'Props Buyer',
  PROPS_DESIGNER: 'Props Designer',
  PROPS_ON_SET: 'Props On Set',
  PROPS_RENTAL_HOUSE: 'Props Rental House',
  PUBLIC_RELATIONS_AGENCY: 'Public Relations Agency',
  PUPPETEER: 'Puppeteer',
  RADIO_HOST: 'Radio Host',
  RAPPER: 'Rapper',
  RECORDIST_ASSIST: 'Recordist Assist.',
  REMOTE_HEAD_TECHNICIAN: 'Remote Head Technician',
  RENTAL_AND_POST_PRODUCTION_COMPANY: 'Rental And Post Production Company',
  RESEARCHER: 'Researcher',
  RIGGING_GRIP: 'Rigging Grip',
  RIGGING_LIGHTING_TECHNICIAN: 'Rigging Lighting Technician',
  ROTO_ARTIST: 'Roto Artist',
  RUNNER_DRIVER: 'Runner Driver',
  SAXOPHONIST: 'Saxophonist',
  SCENIC_PAINTER: 'Scenic Painter',
  SCREENWRITING_ADVISOR: 'Screenwriting Advisor',
  SCRIPT_EDITOR: 'Script Editor',
  SCRIPT_SUPERVISOR: 'Script Supervisor',
  SCRIPTWRITER: 'Scriptwriter',
  SCULPTOR_MOULDER: 'Sculptor Moulder',
  SECOND_ASSIST_ACCOUNTANT: 'Second Assist. Accountant',
  SECOND_ASSIST_CAMERA: '2nd Assist. Camera',
  SECOND_ASSIST_DIRECTOR: '2nd Assist. Director',
  SECOND_ASSIST_SOUND_EDITOR: '2nd Assist. Sound Editor',
  SET_DECORATOR: 'Set Decorator',
  SET_DESIGNER: 'Set Designer',
  SET_DRESSER: 'Set Dresser',
  SFX_ASSIST_TECH: 'SFX Assist. Tech.',
  SFX_COMPANY: 'SFX Company',
  SFX_COORDINATOR: 'SFX Coordinator',
  SFX_KEY_TECHNICIAN: 'SFX Key Technician',
  SFX_MAKE_UP_ARTIST: 'SFX Make-up Artist',
  SFX_TECHNICIAN: 'SFX Technician',
  SHOWRUNNER: 'Showrunner',
  SINGER: 'Singer',
  SOLE_ANIMATION_DIRECTOR: 'Sole Animation Director',
  SONGWRITER: 'Songwriter',
  SOUND_EDITOR: 'Sound Editor',
  SOUND_ENGINEER: 'Sound Engineer',
  SOUND_MIXER: 'Sound Mixer',
  SOUND_RECORDIST: 'Sound Recordist',
  SOUND_STUDIO: 'Sound Studio',
  SPECIALIZED_DECORATION_MAKER: 'Specialized Decoration Maker',
  SPECIALIZED_DRIVER: 'Specialized Driver',
  SPECIALIZED_WARDROBE_TECHNICIAN: 'Specialized Wardrobe Technician',
  SPORTS_COMMENTATOR: 'Sports Commentator',
  STAGE_MANAGER: 'Stage Manager',
  STAGEHAND: 'Stagehand',
  STAND_IN: 'Stand-In',
  STEADICAM_OPERATOR: 'Steadicam Operator',
  STILL_PHOTOGRAPHER: 'Still Photographer',
  STORYBOARD_ARTIST: 'Storyboard Artist',
  STREAMING_PLATFORM: 'Streaming Platform',
  STUNT_COORDINATOR: 'Stunt Coordinator',
  STUNT_DOUBLE: 'Stunt Double',
  STUNTMAN_WOMAN: 'Stuntman/woman',
  SUPERVISING_SOUND_EDITOR: 'Supervising Sound Editor',
  SWITCHER: 'Switcher',
  TALENT_AGENCY: 'Talent Agency',
  TECHNICAL_COORDINATOR: 'Technical Coordinator',
  TECHNICAL_DIRECTOR: 'Technical Director',
  TELEPROMPTER_OPERATOR: 'Teleprompter Operator',
  TELEVISION_HOST: 'Television Host',
  THIRD_ASSIST_ACCOUNTANT: 'Third Assist. Accountant',
  THIRD_ASSIST_DIRECTOR: '3rd Assist. Director',
  THREED_ARTIST: '3D Artist',
  TRAINEE_ACCOUNTANT: 'Trainee Accountant',
  TRANSPORT_CAPTAIN: 'Transport Captain',
  TRANSPORT_COORDINATOR: 'Transport Coordinator',
  TROMBONIST: 'Trombonist',
  TRUMPETER: 'Trumpeter',
  TUBA_PLAYER: 'Tuba Player',
  TWOD_ARTIST: '2D Artist',
  UAV_OPERATOR: 'UAV Operator',
  UKULELE_PLAYER: 'Ukulele Player',
  UNDERWATER_CAMERA_OPERATOR: 'Underwater Camera Operator',
  UNIT_MANAGER: 'Unit Manager',
  VEHICLE_COORDINATOR: 'Vehicle Coordinator',
  VFX_ARTIST: 'VFX Artist',
  VFX_COORDINATOR: 'VFX Coordinator',
  VFX_PRODUCER: 'VFX Producer',
  VFX_STUDIO: 'VFX Studio',
  VFX_SUPERVISOR: 'VFX Supervisor',
  VFX_TECHNICIAN: 'VFX Technician',
  VIDEO_ASSIST_OPERATOR: 'Video-Assist Operator',
  VIDEO_TAPE_OPERATOR: 'Video Tape Operator',
  VIDEOGRAPHER: 'Videographer',
  VIOLINIST: 'Violinist',
  VOICE_ACTOR: 'Voice Actor',
  WARDROBE_MISTRESS: 'Wardrobe Mistress',
  WARDROBE_STYLIST: 'Wardrobe Stylist',
  WARDROBE_TECHNICIAN: 'Wardrobe Technician',
  WELDER: 'Welder',
};

export const WORK_LOCATION_SHORT_LABELS = {
  AR_B_LA_PLATA: 'La Plata, AR',
  AR_B_MAR_DEL_PLATA: 'Mar del Plata, AR',
  AR_C_BUENOS_AIRES: 'Buenos Aires, AR',
  AR_M_MENDOZA: 'Mendoza, AR',
  AR_S_ROSARIO: 'Rosario, AR',
  AR_S_SANTA_FE: 'Santa Fe, AR',
  AR_X_CORDOBA: 'Córdoba, AR',
  AT_5_SALZBURG: 'Salzburg, AT',
  AT_9_VIENNA: 'Vienna, AT',
  AU_NSW_SYDNEY: 'Sydney, NSW, AU',
  AU_QLD_BRISBANE: 'Brisbane, QLD, AU',
  AU_SA_ADELAIDE: 'Adelaide, SA, AU',
  AU_VIC_MELBOURNE: 'Melbourne, VIC, AU',
  AU_WA_PERTH: 'Perth, WA, AU',
  BE_BRU_BRUSSELS: 'Brussels, BE',
  BE_VLG_ANTWERP: 'Antwerp, BE',
  BE_VOV_GHENT: 'Ghent, BE',
  BG_16_PLOVDIV: 'Plovdiv, BG',
  BG_22_SOFIA: 'Sofia, BG',
  BR_AM_MANAUS: 'Manaus, AM, BR',
  BR_BA_SALVADOR: 'Salvador, BA, BR',
  BR_DF_BRASILIA: 'Brasília, DF, BR',
  BR_MG_BELO_HORIZONTE: 'Belo Horizonte, MG, BR',
  BR_PE_RECIFE: 'Recife, PE, BR',
  BR_PR_CURITIBA: 'Curitiba, PR, BR',
  BR_RJ_RIO_DE_JANEIRO: 'Rio de Janeiro, RJ, BR',
  BR_RS_PORTO_ALEGRE: 'Porto Alegre, RS, BR',
  BR_SP_SAO_PAULO: 'São Paulo, SP, BR',
  CA_AB_CALGARY: 'Calgary, AB, CA',
  CA_AB_EDMONTON: 'Edmonton, AB, CA',
  CA_BC_KAMLOOPS: 'Kamloops, BC, CA',
  CA_BC_KELOWNA: 'Kelowna, BC, CA',
  CA_BC_VANCOUVER: 'Vancouver, BC, CA',
  CA_BC_VICTORIA: 'Victoria, BC, CA',
  CA_BC_WHISTLER: 'Whistler, BC, CA',
  CA_MB_WINNIPEG: 'Winnipeg, MB, CA',
  CA_NB_FREDERICTON: 'Fredericton, NB, CA',
  CA_NB_MONCTON: 'Moncton, NB, CA',
  CA_NB_SAINT_JOHN: 'Saint John, NB, CA',
  CA_NL_ST_JOHNS: 'St. John\'s, NL, CA',
  CA_NS_HALIFAX: 'Halifax, NS, CA',
  CA_NT_YELLOWKNIFE: 'Yellowknife, NT, CA',
  CA_NU_IQALUIT: 'Iqaluit, NU, CA',
  CA_ON_HAMILTON: 'Hamilton, ON, CA',
  CA_ON_KINGSTON: 'Kingston, ON, CA',
  CA_ON_LONDON: 'London, ON, CA',
  CA_ON_OTTAWA: 'Ottawa, ON, CA',
  CA_ON_SUDBURY: 'Sudbury, ON, CA',
  CA_ON_THUNDER_BAY: 'Thunder Bay, ON, CA',
  CA_ON_TORONTO: 'Toronto, ON, CA',
  CA_ON_WINDSOR: 'Windsor, ON, CA',
  CA_PE_CHARLOTTETOWN: 'Charlottetown, PE, CA',
  CA_QC_GATINEAU: 'Gatineau, QC, CA',
  CA_QC_MONTREAL: 'Montreal, QC, CA',
  CA_QC_QUEBEC: 'Quebec, QC, CA',
  CA_QC_SHERBROOKE: 'Sherbrooke, QC, CA',
  CA_QC_TROIS_RIVIERES: 'Trois-Rivières, QC, CA',
  CA_SK_REGINA: 'Regina, SK, CA',
  CA_SK_SASKATOON: 'Saskatoon, SK, CA',
  CA_YT_WHITEHORSE: 'Whitehorse, YT, CA',
  CH_GE_GENEVA: 'Geneva, CH',
  CH_ZH_ZURICH: 'Zurich, CH',
  CZ_20_PRAGUE: 'Prague, CZ',
  DE_BB_POTSDAM: 'Potsdam, DE',
  DE_BE_BERLIN: 'Berlin, DE',
  DE_BW_LUDWIGSBURG: 'Ludwigsburg, DE',
  DE_BW_STUTTGART: 'Stuttgart, DE',
  DE_BY_MUNICH: 'Munich, DE',
  DE_HB_BREMEN: 'Bremen, DE',
  DE_HE_FRANKFURT: 'Frankfurt, DE',
  DE_HH_HAMBURG: 'Hamburg, DE',
  DE_NI_HANOVER: 'Hanover, DE',
  DE_NW_COLOGNE: 'Cologne, DE',
  DE_NW_DUSSELDORF: 'Düsseldorf, DE',
  DE_SN_DRESDEN: 'Dresden, DE',
  DE_SN_LEIPZIG: 'Leipzig, DE',
  DK_84_COPENHAGEN: 'Copenhagen, DK',
  EE_37_TALLINN: 'Tallinn, EE',
  ES_AN_MALAGA: 'Malaga, ES',
  ES_AN_SEVILLE: 'Seville, ES',
  ES_CN_GRAN_CANARIA: 'Gran Canaria, ES',
  ES_CN_TENERIFE: 'Tenerife, ES',
  ES_CT_BARCELONA: 'Barcelona, ES',
  ES_MD_MADRID: 'Madrid, ES',
  ES_PV_BILBAO: 'Bilbao, ES',
  ES_VC_VALENCIA: 'Valencia, ES',
  FI_11_TAMPERE: 'Tampere, FI',
  FI_18_HELSINKI: 'Helsinki, FI',
  FR_ARA_ANNECY: 'Annecy, FR',
  FR_ARA_LYON: 'Lyon, FR',
  FR_BFC_DIJON: 'Dijon, FR',
  FR_BRE_BREST: 'Brest, FR',
  FR_BRE_RENNES: 'Rennes, FR',
  FR_COR_AJACCIO: 'Ajaccio, FR',
  FR_COR_BASTIA: 'Bastia, FR',
  FR_CVL_ORLEANS: 'Orléans, FR',
  FR_CVL_TOURS: 'Tours, FR',
  FR_GES_STRASBOURG: 'Strasbourg, FR',
  FR_GF_GUYANE: 'Guyane, FR',
  FR_GP_GUADELOUPE: 'Guadeloupe, FR',
  FR_HDF_AMIENS: 'Amiens, FR',
  FR_HDF_LILLE: 'Lille, FR',
  FR_IDF_PARIS: 'Paris, FR',
  FR_MQ_MARTINIQUE: 'Martinique, FR',
  FR_NAQ_BIARRITZ: 'Biarritz, FR',
  FR_NAQ_BORDEAUX: 'Bordeaux, FR',
  FR_NAQ_LA_ROCHELLE: 'La Rochelle, FR',
  FR_NOR_CAEN: 'Caen, FR',
  FR_NOR_LE_HAVRE: 'Le Havre, FR',
  FR_NOR_ROUEN: 'Rouen, FR',
  FR_OCC_MONTPELLIER: 'Montpellier, FR',
  FR_OCC_TOULOUSE: 'Toulouse, FR',
  FR_PAC_CANNES: 'Cannes, FR',
  FR_PAC_MARSEILLE: 'Marseille, FR',
  FR_PAC_NICE: 'Nice, FR',
  FR_PDL_ANGERS: 'Angers, FR',
  FR_PDL_NANTES: 'Nantes, FR',
  FR_RE_LA_REUNION: 'La Réunion, FR',
  GB_ENG_BIRMINGHAM: 'Birmingham, GB',
  GB_ENG_BRIGHTON: 'Brighton, GB',
  GB_ENG_BRISTOL: 'Bristol, GB',
  GB_ENG_LEEDS: 'Leeds, GB',
  GB_ENG_LIVERPOOL: 'Liverpool, GB',
  GB_ENG_LONDON: 'London, GB',
  GB_ENG_MANCHESTER: 'Manchester, GB',
  GB_ENG_NEWCASTLE: 'Newcastle, GB',
  GB_ENG_NOTTINGHAM: 'Nottingham, GB',
  GB_NIR_BELFAST: 'Belfast, GB',
  GB_SCT_EDINBURGH: 'Edinburgh, GB',
  GB_SCT_GLASGOW: 'Glasgow, GB',
  GB_WLS_CARDIFF: 'Cardiff, GB',
  GE_AJ_BATUMI: 'Batumi, GE',
  GE_TB_TBILISI: 'Tbilisi, GE',
  GR_B_THESSALONIKI: 'Thessaloniki, GR',
  GR_I_ATHENS: 'Athens, GR',
  HU_BU_BUDAPEST: 'Budapest, HU',
  ID_BA_DENPASAR: 'Denpasar, Bali, ID',
  ID_JK_JAKARTA: 'Jakarta, ID',
  IE_CO_CORK: 'Cork, IE',
  IE_D_DUBLIN: 'Dublin, IE',
  IE_LK_LIMERICK: 'Limerick, IE',
  IT_21_TURIN: 'Turin, IT',
  IT_25_MILAN: 'Milan, IT',
  IT_34_VENICE: 'Venice, IT',
  IT_42_GENOA: 'Genoa, IT',
  IT_45_BOLOGNA: 'Bologna, IT',
  IT_52_FLORENCE: 'Florence, IT',
  IT_62_ROME: 'Rome, IT',
  IT_72_NAPLES: 'Naples, IT',
  IT_82_PALERMO: 'Palermo, IT',
  JP_13_TOKYO: 'Tokyo, JP',
  JP_14_YOKOHAMA: 'Yokohama, JP',
  JP_26_KYOTO: 'Kyoto, JP',
  JP_27_OSAKA: 'Osaka, JP',
  KR_11_SEOUL: 'Seoul, KR',
  KR_26_BUSAN: 'Busan, KR',
  KR_41_GOYANG: 'Goyang, KR',
  LT_KU_KAUNAS: 'Kaunas, LT',
  LT_VL_VILNIUS: 'Vilnius, LT',
  LU_L_LUXEMBOURG_CITY: 'Luxembourg City, LU',
  LV_RIX_RIGA: 'Riga, LV',
  MA_06_CASABLANCA: 'Casablanca, MA',
  MA_07_MARRAKECH: 'Marrakech, MA',
  MA_09_OUARZAZATE: 'Ouarzazate, MA',
  MX_BCN_ENSENADA: 'Ensenada, BC, MX',
  MX_BCN_ROSARITO: 'Rosarito, BC, MX',
  MX_BCN_TIJUANA: 'Tijuana, BC, MX',
  MX_BCS_LOS_CABOS: 'Los Cabos, BCS, MX',
  MX_CAM_CAMPECHE_CITY: 'Campeche City, CAMP, MX',
  MX_CHH_CIUDAD_JUAREZ: 'Ciudad Juárez, CHIH, MX',
  MX_CHP_SAN_CRISTOBAL: 'San Cristóbal, CHIS, MX',
  MX_CMX_MEXICO_CITY: 'Mexico City, CDMX, MX',
  MX_DUR_DURANGO_CITY: 'Durango City, DGO, MX',
  MX_GRO_ACAPULCO: 'Acapulco, GRO, MX',
  MX_GUA_LEON: 'León, GTO, MX',
  MX_JAL_GUADALAJARA: 'Guadalajara, JAL, MX',
  MX_JAL_PUERTO_VALLARTA: 'Puerto Vallarta, JAL, MX',
  MX_MIC_MORELIA: 'Morelia, MICH, MX',
  MX_NLE_MONTERREY: 'Monterrey, NL, MX',
  MX_OAX_OAXACA_CITY: 'Oaxaca City, OAX, MX',
  MX_PUE_PUEBLA_CITY: 'Puebla City, PUE, MX',
  MX_ROO_CANCUN: 'Cancún, QROO, MX',
  MX_SLP_SAN_LUIS_POTOSI_CITY: 'San Luis Potosí City, SLP, MX',
  MX_VER_VERACRUZ_CITY: 'Veracruz City, VER, MX',
  MX_YUC_MERIDA: 'Mérida, YUC, MX',
  MX_ZAC_ZACATECAS_CITY: 'Zacatecas City, ZAC, MX',
  MY_01_ISKANDAR_JOHOR_BAHRU: 'Iskandar/Johor Bahru, MY',
  MY_14_KUALA_LUMPUR: 'Kuala Lumpur, MY',
  NO_03_OSLO: 'Oslo, NO',
  NO_46_BERGEN: 'Bergen, NO',
  NZ_AUK_AUCKLAND: 'Auckland, NZ',
  NZ_CAN_CHRISTCHURCH: 'Christchurch, NZ',
  NZ_OTA_QUEENSTOWN: 'Queenstown, NZ',
  NZ_WGN_WELLINGTON: 'Wellington, NZ',
  PH_00_MANILA_QUEZON_CITY: 'Manila/Quezon City, PH',
  PH_CEB_CEBU_CITY: 'Cebu City, PH',
  PL_02_WROCLAW: 'Wroclaw, PL',
  PL_10_LODZ: 'Lodz, PL',
  PL_12_KRAKOW: 'Krakow, PL',
  PL_14_WARSAW: 'Warsaw, PL',
  PL_24_KATOWICE: 'Katowice, PL',
  PL_30_POZNAN: 'Poznan, PL',
  PT_11_LISBON: 'Lisbon, PT',
  PT_13_PORTO: 'Porto, PT',
  RO_B_BUCHAREST: 'Bucharest, RO',
  RO_CT_CONSTANTA: 'Constanta, RO',
  RS_00_BELGRADE: 'Belgrade, RS',
  RU_MOW_MOSCOW: 'Moscow, RU',
  RU_SPE_ST_PETERSBURG: 'St. Petersburg, RU',
  SA_01_RIYADH: 'Riyadh, SA',
  SA_02_JEDDAH: 'Jeddah, SA',
  SE_AB_STOCKHOLM: 'Stockholm, SE',
  SE_M_MALMO: 'Malmö, SE',
  SE_O_GOTHENBURG: 'Gothenburg, SE',
  SG_01_SINGAPORE: 'Singapore, SG',
  SK_BL_BRATISLAVA: 'Bratislava, SK',
  TH_10_BANGKOK: 'Bangkok, TH',
  TH_50_CHIANG_MAI: 'Chiang Mai, TH',
  TH_83_PHUKET: 'Phuket, TH',
  TR_06_ANKARA: 'Ankara, TR',
  TR_07_ANTALYA: 'Antalya, TR',
  TR_34_ISTANBUL: 'Istanbul, TR',
  TR_35_IZMIR: 'Izmir, TR',
  TR_61_TRABZON: 'Trabzon, TR',
  UA_32_KYIV: 'Kyiv, UA',
  UA_51_ODESA: 'Odesa, UA',
  US_AK_ANCHORAGE: 'Anchorage, AK, US',
  US_AL_BIRMINGHAM: 'Birmingham, AL, US',
  US_AL_MONTGOMERY: 'Montgomery, AL, US',
  US_AR_LITTLE_ROCK: 'Little Rock, AR, US',
  US_AZ_PHOENIX: 'Phoenix, AZ, US',
  US_CA_LOS_ANGELES: 'Los Angeles, CA, US',
  US_CA_SACRAMENTO: 'Sacramento, CA, US',
  US_CA_SAN_DIEGO: 'San Diego, CA, US',
  US_CA_SAN_FRANCISCO: 'San Francisco, CA, US',
  US_CO_DENVER: 'Denver, CO, US',
  US_CT_HARTFORD: 'Hartford, CT, US',
  US_CT_NEW_HAVEN: 'New Haven, CT, US',
  US_DE_WILMINGTON: 'Wilmington, DE, US',
  US_FL_MIAMI: 'Miami, FL, US',
  US_FL_ORLANDO: 'Orlando, FL, US',
  US_FL_TAMPA_BAY: 'Tampa Bay, FL, US',
  US_GA_ATLANTA: 'Atlanta, GA, US',
  US_GA_SAVANNAH: 'Savannah, GA, US',
  US_HI_HONOLULU: 'Honolulu, HI, US',
  US_IA_DES_MOINES: 'Des Moines, IA, US',
  US_ID_BOISE: 'Boise, ID, US',
  US_IL_CHICAGO: 'Chicago, IL, US',
  US_IN_INDIANAPOLIS: 'Indianapolis, IN, US',
  US_KS_WICHITA: 'Wichita, KS, US',
  US_KY_LOUISVILLE: 'Louisville, KY, US',
  US_LA_BATON_ROUGE: 'Baton Rouge, LA, US',
  US_LA_NEW_ORLEANS: 'New Orleans, LA, US',
  US_MA_BOSTON: 'Boston, MA, US',
  US_MD_BALTIMORE: 'Baltimore, MD, US',
  US_ME_PORTLAND: 'Portland, ME, US',
  US_MI_DETROIT: 'Detroit, MI, US',
  US_MN_MINNEAPOLIS: 'Minneapolis, MN, US',
  US_MO_KANSAS_CITY: 'Kansas City, MO, US',
  US_MO_ST_LOUIS: 'St Louis, MO, US',
  US_MS_JACKSON: 'Jackson, MS, US',
  US_MT_BOZEMAN: 'Bozeman, MT, US',
  US_MT_MISSOULA: 'Missoula, MT, US',
  US_NC_CHARLOTTE: 'Charlotte, NC, US',
  US_NC_WILMINGTON: 'Wilmington, NC, US',
  US_ND_FARGO: 'Fargo, ND, US',
  US_NE_OMAHA: 'Omaha, NE, US',
  US_NH_MANCHESTER: 'Manchester, NH, US',
  US_NJ_JERSEY_CITY: 'Jersey City, NJ, US',
  US_NJ_NEWARK: 'Newark, NJ, US',
  US_NM_ALBUQUERQUE: 'Albuquerque, NM, US',
  US_NM_SANTA_FE: 'Santa Fe, NM, US',
  US_NV_LAS_VEGAS: 'Las Vegas, NV, US',
  US_NY_BUFFALO: 'Buffalo, NY, US',
  US_NY_HUDSON_VALLEY: 'Hudson Valley, NY, US',
  US_NY_NEW_YORK_CITY: 'New York City, NY, US',
  US_OH_CINCINNATI: 'Cincinnati, OH, US',
  US_OH_CLEVELAND: 'Cleveland, OH, US',
  US_OK_OKLAHOMA_CITY: 'Oklahoma City, OK, US',
  US_OK_TULSA: 'Tulsa, OK, US',
  US_OR_PORTLAND: 'Portland, OR, US',
  US_PA_PHILADELPHIA: 'Philadelphia, PA, US',
  US_PA_PITTSBURGH: 'Pittsburgh, PA, US',
  US_RI_PROVIDENCE: 'Providence, RI, US',
  US_SC_CHARLESTON: 'Charleston, SC, US',
  US_SD_SIOUX_FALLS: 'Sioux Falls, SD, US',
  US_TN_MEMPHIS: 'Memphis, TN, US',
  US_TN_NASHVILLE: 'Nashville, TN, US',
  US_TX_AUSTIN: 'Austin, TX, US',
  US_TX_DALLAS_FORT_WORTH: 'Dallas-Fort Worth, TX, US',
  US_TX_HOUSTON: 'Houston, TX, US',
  US_UT_SALT_LAKE_CITY: 'Salt Lake City, UT, US',
  US_VA_NORFOLK: 'Norfolk, VA, US',
  US_VA_RICHMOND: 'Richmond, VA, US',
  US_VT_BURLINGTON: 'Burlington, VT, US',
  US_WA_SEATTLE: 'Seattle, WA, US',
  US_WI_MILWAUKEE: 'Milwaukee, WI, US',
  US_WV_CHARLESTON: 'Charleston, WV, US',
  US_WY_JACKSON_HOLE: 'Jackson Hole, WY, US',
  ZA_GP_JOHANNESBURG: 'Johannesburg, ZA',
  ZA_KZN_DURBAN: 'Durban, ZA',
  ZA_WC_CAPE_TOWN: 'Cape Town, ZA',
};
